import React  from 'react';
import { CheckboxGroup, Input } from "../Shared/Form";
import { WizardButtons } from "../Wizard";
import { NextButton, ResetButton, PrevButton } from "../Shared/Buttons";
import { actions, useStore } from "../store";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { informationFormSchema } from "../schema";
import PropTypes from "prop-types";

const InformationStep = ({ stepName }) => {
  const [informationFormData, addInformationFormDataByKey, removeInformationFormDataByKey] =
    useStore(state => [state.informationFormData, state.addInformationFormDataByKey, state.removeInformationFormDataByKey])
  const [informationFormValue, setInformationFormValue, changeInformationFormValue ] =
    useStore(state => [state.informationFormValue, state.setInformationFormValue, state.changeInformationFormValue])
  const removeSuccessSteps = useStore(state => state.removeSuccessSteps)

  const formMethods = useForm({
    mode: 'onBlur',
    shouldFocusError: false,
    resolver: yupResolver(informationFormSchema),
    defaultValues: informationFormValue,
  });

  const handleChange = (fieldName, value) => {
    changeInformationFormValue(fieldName, value)
    removeSuccessSteps(stepName)
  }

  const onSubmit = (data) => {
    setInformationFormValue(data);
    actions.handleWizardNextStep()
  }

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)}>
        <div className="card shadow-lg">
          <div className="card-header">
            <h3 className="card-title">
              Specify what information about your users do you collect and how it is collected.
            </h3>
          </div>
          <div className="card-body">
            <div className='row'>
              <div className='col-lg-6 col-md-6 col-sm-12'>
                <p className='fw-bold required'>What information do you collect?</p>
                <div className='d-flex flex-column'>
                  <CheckboxGroup
                    options={informationFormData.collectInfo}
                    name='collectInfo'
                    handleChange={handleChange}
                    isMoreAction={true}
                    handleAddMoreItem={addInformationFormDataByKey}
                    handleRemoveMoreItem={removeInformationFormDataByKey}
                  />
                </div>
              </div>
              <div className='col-lg-6 col-md-6 col-sm-12'>
                <p className='fw-bold required'>How do you collect the information?</p>
                <div className='d-flex flex-column'>
                  <CheckboxGroup
                    options={informationFormData.wayCollect}
                    name='wayCollect'
                    handleChange={handleChange}
                    isMoreAction={true}
                    handleAddMoreItem={addInformationFormDataByKey}
                    handleRemoveMoreItem={removeInformationFormDataByKey}
                  />
                </div>
              </div>
            </div>
            <div className='row mt-4'>
              <div className='col-12'>
                <p className='fw-bold required'>How many days will collected user information be stored after it is no longer needed?</p>
              </div>
              <div className='col-lg-4 col-md-4 col-sm-12'>
                <Input
                  floating={true}
                  labelText='Number of days'
                  name='collectDays'
                  type='number'
                  handleChange={handleChange}
                  placeholder="30"
                />
              </div>
            </div>
          </div>
          <div className='card-footer'>
            <WizardButtons>
              <>
                <PrevButton onClick={() => actions.handleWizardPrevStep()} />
                <ResetButton onClick={() => actions.handleWizardReset()} />
                <NextButton type='submit' />
              </>
            </WizardButtons>

          </div>
        </div>
      </form>
    </FormProvider>
  );
}

InformationStep.propTypes = {
  stepName: PropTypes.string.isRequired,
}

export default InformationStep;
